import {useIssueFormSecondaryQuery} from '@github-ui/server-persisted-queries'
import type {UseIssueFormSecondaryQueryQuery} from '@github-ui/server-persisted-queries/types/useIssueFormSecondaryQuery'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export type IssueFormSecondaryRepository = Extract<
  UseIssueFormSecondaryQueryQuery['node'],
  {readonly __typename: 'Repository'}
>

export function issueFormSecondaryQueryKey(owner: string, repo: string) {
  return ['issue-create', 'issue-form-secondary', {owner, repo}] as const
}

export async function fetchIssueFormSecondary(
  owner: string,
  repo: string,
  signal?: AbortSignal,
): Promise<IssueFormSecondaryRepository> {
  const search = new URLSearchParams({queryId: useIssueFormSecondaryQuery})
  const response = await verifiedFetchJSON(
    `/${encodeURIComponent(owner)}/${encodeURIComponent(repo)}/issues/new/issue_form_secondary?${search}`,
    {signal},
  )
  if (!response.ok) throw new Error(`Issue form secondary fetch failed (${response.status})`)

  const json = (await response.json()) as {data?: UseIssueFormSecondaryQueryQuery; errors?: unknown[]}
  if (json.errors?.length || !json.data) throw new Error('useIssueFormSecondaryQuery returned errors')

  const node = json.data.node
  if (!node || node.__typename !== 'Repository') throw new Error('useIssueFormSecondaryQuery returned no repository')

  return node
}
